import { render, staticRenderFns } from "./MdCaseShow.vue?vue&type=template&id=168f709e&scoped=true&"
import script from "./MdCaseShow.vue?vue&type=script&lang=js&"
export * from "./MdCaseShow.vue?vue&type=script&lang=js&"
import style0 from "./MdCaseShow.vue?vue&type=style&index=0&id=168f709e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f709e",
  null
  
)

export default component.exports